// component
import PopupTop from 'components/atoms/popup-top/popup-top'
// content
import { useHome } from 'hooks/contentful'
// services
import LiveService from '../services/live'
import AuthService from '../../Auth/services/auth'
// hooks
import useAudit from 'hooks/useAudit'
import useUIActions from 'hooks/useUIActions'
import useLiveQueries from './useLiveQueries'
// libraries
import dayjs from '../../../utils/dayjs-config'
import { useState, useEffect } from 'react'
// redux
import { useSelector } from 'react-redux'
// router
import { useHistory, useLocation } from 'react-router-dom'

export default function useLive({ idInsideLive = false } = {}) {
	// redux
	const {
		session: { userWithoutLogin, userGigya, email, userId }
		// activePatient: { userId }
	} = useSelector(state => state)

	// Cache de Tanstack Query (mantiene la lógica existente)
	const { getCachedLives, getCachedAllLives, invalidateLives } = useLiveQueries(userId)

	// data state
	const [liveData, setLiveData] = useState([])
	const [allDataLive, setAllDataLive] = useState([])
	const [liveContent, setLiveContent] = useState(false)
	const [liveLoading, setLiveLoading] = useState(false)
	const [isCurrentLive, setIsCurrentLive] = useState(false)

	// hooks
	const { handleShowPopupTop, showOverlay } = useUIActions()
	const { events, handledSaveEventRegistry } = useAudit()

	// content
	const {
		ourLives: { beneficioCollection }
	} = useHome()

	// router
	const history = useHistory()
	const { pathname } = useLocation()

	// actions - AHORA CON CACHE
	const getLives = () => {
		setLiveLoading(true)
		if (!userId) return null
		getCachedLives()
			.then(res => {
				setLiveLoading(false)
				if (res.status === 200) {
					return setLiveData(res.data)
				}
			})
			.catch(() => {
				setLiveLoading(false)
			})
	}

	const getLivesTodayLives = () => {
		setLiveLoading(true)
		if (!userId) return null
		getCachedAllLives()
			.then(res => {
				setLiveLoading(false)
				if (res.status === 200) {
					return setAllDataLive(res.data)
				}
			})
			.catch(() => {
				setLiveLoading(false)
			})
	}

	const reserveLives = idLive => {
		setLiveLoading(true)

		const payload = {
			meetingId: idLive,
			email: userWithoutLogin && !userGigya ? email : null,
			userId
		}

		handledSaveEventRegistry({
			eventName: events[14],
			caller: `Registry - ${idLive}`,
			trackTime: null
		})

		LiveService.postLiveReserve({ userId, payload })
			.then(res => {
				setLiveLoading(false)
				if (res.status === 200) {
					handleShowPopupTop(<PopupTop type='success' label={res.message} />)
					// Invalidar cache después de reservar
					invalidateLives()
					if (res.data) return setLiveData([...liveData, res.data])
					return getLives()
				}
			})
			.catch(() => {
				setLiveLoading(false)
			})
	}

	const isReserved = ({ dataLive, idValidate }) =>
		dataLive && dataLive.some(live => live.meetingNumber === idValidate)

	const validateIsLive = currentData => {
		// dates
		const dateFormat = 'YYYY/MM/DD HH:mm:ss'
		const toDay = dayjs().add(1, 'minute').format(dateFormat)
		const finalHour = dayjs().format(dateFormat)

		const isInRage =
			currentData.find(
				date =>
					dayjs(date.startDate).format(dateFormat) <= toDay &&
					dayjs(date.finishDate).format(dateFormat) >= finalHour
			) || false

		setIsCurrentLive(
			isInRage
				? { beneficioCollection, extraData: isInRage, meetingNumber: isInRage.meetingNumber }
				: false
		)
	}
	const setCaller = ({ fromHead, id }) => {
		if (fromHead && isCurrentLive) return isCurrentLive.meetingNumber
		if (id) return id
		return false
	}

	const controlLive = ({ id, fromHead = false }) => {
		handledSaveEventRegistry({
			eventName: events[14],
			caller: setCaller({ id, fromHead }),
			trackTime: null
		})

		if ((isCurrentLive && id === isCurrentLive.meetingNumber) || (fromHead && isCurrentLive)) {
			return showOverlay({
				open: true,
				element: isCurrentLive,
				id: isCurrentLive.meetingNumber,
				template: 'live'
			})
		}

		if (id) return history.push(`/envivos/${id}`)

		return history.push('/envivos')
	}

	useEffect(() => {
		validateIsLive(allDataLive)

		const timeLive = setInterval(() => validateIsLive(allDataLive), 1000 * 60 * 0.5)
		return () => clearTimeout(timeLive)
	}, [allDataLive])

	useEffect(() => {
		if (!idInsideLive || liveData.length === 0) return null

		setLiveContent(liveData.find(e => e.meetingNumber === idInsideLive) || false)
	}, [idInsideLive, liveData])

	useEffect(() => {
		if (pathname.includes('/par-q-public')) return
		if (!AuthService.isLoggedIn(true)) return

		getLives()
		getLivesTodayLives()
	}, [pathname])

	const liveActions = {
		controlLive,
		reserveLives,
		isReserved
	}

	const liveState = {
		loading: liveLoading,
		data: liveData,
		isCurrentLive,
		allDataLive,
		liveContent
	}

	return {
		liveState,
		liveActions
	}
}
